import { useEffect, useState } from "react";
import TopHeadScreen from "../../component/layout/tophead";
import SidebarScreen from "../../component/layout/sidebar";
import AuthFooterScreen from "../../component/layout/authfooter";
import Form from "react-bootstrap/Form";
import LocationIcon from "@/../../public/images/locationIcon.svg";
import SearchIcon from "@/../../public/images/search.svg";
import BriefcaseIcon from "@/../../public/images/lucide_briefcase-business.svg";
import { BsSliders } from "react-icons/bs";
import Button from "react-bootstrap/Button";
import { Badge } from "react-bootstrap";

import Offcanvas from "react-bootstrap/Offcanvas";

import MultiRangeSlider from "multi-range-slider-react";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import AgentSidebarScreen from "../../component/layout/agent-sidebar";
import AgentTopHeadScreen from "../../component/layout/agent-header";

import JobsList from "../../component/jobs-list";
import { jobCategoryApi, jobSalaryRangeApi, jobTypeApi } from "../../service/apis/employer.api";

const JobsListingScreen = () => {
  const [jobCategory, setJobCategory] = useState([]);
  const [jobType, setJobType] = useState([]);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const { user } = useSelector((state: RootState) => state.authSlice);


  // 24-12-24
  const [categories, setCategories] = useState<string[]>([]);
  const [jobTypes, setJobTypes] = useState<string[]>([]);

  const [salaryMin, setSalaryMin] = useState<number | null>(null);
  const [salaryMax, setSalaryMax] = useState<number | null>(null);
  const [salaryRange, setSalaryRange] = useState({ minSalary: 0, maxSalary: 0 });

  //const [industry, setIndustry] = useState("");
  //const [location, setLocation] = useState("");

  const [formValues, setFormValues] = useState({
    industry: "",
    location: "",
  });

  //const [error, setError] = useState("");

  /*const handleInputChange = (e: any) => {
		e.preventDefault();
		const { name, value } = e.target;
		setFormValues((prev) => ({ ...prev, [name]: value }));
	};*/

  const handleSubmit = (e: any) => {
    e.preventDefault();

    const formData = new FormData(e.currentTarget); // Capture form data
    const industry = formData.get("industry") as string;
    const location = formData.get("location") as string;

    /*if (!industry && !location) {
			setError("Both fields are required."); 
			return; 
		}
	
		setError("");*/

    //setFormValues(formValues);
    setFormValues({ industry, location });
  };

  const handleCheckboxChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | { minValue: number; maxValue: number },
    type: "category" | "jobType" | "salary"
  ) => {
    if (type === "category" || type === "jobType") {
      const value = (e as React.ChangeEvent<HTMLInputElement>).target.value;
      const label = (
        e as React.ChangeEvent<HTMLInputElement>
      ).target.getAttribute("cat-name");
      const isChecked = (e as React.ChangeEvent<HTMLInputElement>).target
        .checked;

      if (type === "category") {
        setCategories((prev: any) =>
          isChecked
            ? [...prev, { label, value }]
            : prev.filter((item: any) => item.value !== value)
        );
      } else if (type === "jobType") {
        setJobTypes((prev: any) =>
          //isChecked ? [...prev, value] : prev.filter((item: any) => item !== value)
          isChecked
            ? [...prev, { label, value }]
            : prev.filter((item: any) => item.value !== value)
        );
      }
    } else if (type === "salary") {
      const { minValue, maxValue } = e as {
        minValue: number;
        maxValue: number;
      };
      setSalaryMin(minValue);
      setSalaryMax(maxValue);
    }
  };
  // 24-12-24 ends

  const removeTag = (value: any, filterType: any) => {
    if (filterType === "category") {
      setCategories((prev: any) =>
        prev.filter((category: any) => category !== value)
      );
    } else if (filterType === "jobType") {
      setJobTypes((prev: any) =>
        prev.filter((jobType: any) => jobType !== value)
      );
    }
  };

  // const handleApplyFilter = () => {
  //   //console.log("Selected Categories:", categories);
  //   //console.log("Selected Job Types:", jobTypes);
  //   //console.log("Selected Salary Range:", salaryMin, "-", salaryMax);

  //   // Close the Offcanvas
  //   handleClose();
  // };

  const jobCategoryLists = async () => {
    //setIsLoading(true);
    try {
      const response = await jobCategoryApi();
      setJobCategory(response.categories);
    } catch (error) {
      console.error("Catch Error: ", error);
    } finally {
      //setIsLoading(false);
    }
  };

  const jobTypeLists = async () => {
    //setIsLoading(true);
    try {
      const response = await jobTypeApi();
      setJobType(response.types);
    } catch (error) {
      console.error("Catch Error: ", error);
    } finally {
      //setIsLoading(false);
    }
  };

  const jobSalaryRange = async () => {
      try {
        const response = await jobSalaryRangeApi();
  
        if (response?.salary?.[0]) {
            const minSalary=response.salary[0].minSalary;
            const maxSalary=response.salary[0].maxSalary;
            setSalaryMin(minSalary);
            setSalaryMax(maxSalary);
            setSalaryRange({
                minSalary: minSalary,
                maxSalary: maxSalary,
            });
        }
      } catch (error) {
        console.error("Catch Error: ", error);
      }
    };

  useEffect(() => {
    jobCategoryLists();
    jobTypeLists();
    jobSalaryRange();
  }, []);

  /*const handleSortChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const selectedValue = e.target.value;
		setSortOrder(selectedValue);
	};*/

  // Sort
  const [sortOrder, setSortOrder] = useState<any>("");

  const handleSortChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = e.target.value;
    setSortOrder(selectedValue);
  };
  // Sort ends

  return (
    <>
      <div className="main">
        <section className="profileJoblisting-area">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-2 sidebar  p-0">
                {user && user?.role === "jobseeker" && <SidebarScreen />}
                {user && user?.role === "localagents" && <AgentSidebarScreen />}
              </div>
              <div className="col-lg-10 rightcontent p-0">
                {user && user?.role === "jobseeker" && <TopHeadScreen />}
                {user && user?.role === "localagents" && <AgentTopHeadScreen />}
                <div className="profileJoblisting-holder rightInnerScroll">
                  <div className="row">
                    <div className="col-lg-12 pt-3 mb-4">
                      <div className="title">
                        <h2>Jobs</h2>
                      </div>
                      <div className="filterHolder">
                        <div className="filterResults">
                          <Form className="homesearch" onSubmit={handleSubmit}>
                            {/* {error && <Alert variant="danger">{error}</Alert>} */}
                            <Form.Group className="iconinside border-right">
                              <div className="icon">
                                <img src={BriefcaseIcon} alt="Briefcase Icon" />
                              </div>
                              <Form.Control
                                type="text"
                                name="industry"
                                placeholder="Keyword or Job title"

                                //value={formValues.industry}
                                //onChange={handleInputChange}
                              />
                            </Form.Group>
                            <Form.Group className=" iconinside">
                              <div className="icon">
                                <img src={LocationIcon} alt="Location Icon" />
                              </div>
                              <Form.Control
                                type="text"
                                name="location"
                                placeholder="Location"

                                //value={formValues.location}
                                //onChange={handleInputChange}
                              />
                            </Form.Group>
                            <Button
                              className="btn btn-black w-100"
                              type="submit"
                            >
                              {" "}
                              <img src={SearchIcon} alt="Search Icon" /> Search
                            </Button>
                          </Form>
                        </div>
                        <div className="filter-sort">
                          <div className="filter-holder">
                            <Button
                              variant="primary"
                              onClick={handleShow}
                              className="me-5 allfilter"
                            >
                              <BsSliders /> Filter
                            </Button>
                          </div>
                          <div className="sortby-holder">
                            <h6>Sort By:</h6>
                            <Form.Select
                              aria-label="Default select example"
                              onChange={handleSortChange}
                              value={sortOrder}
                            >
                              <option value="">Default</option>
                              <option value="newest">Newest</option>
                              <option value="oldest">Oldest</option>
                              <option value="asc">A to Z</option>
                              <option value="desc">Z to A</option>
                            </Form.Select>
                          </div>
                        </div>
                      </div>

                      {/* Tags Display */}
                      <div className="tags-container">
                        {categories &&
                          categories.map((category: any, index: any) => (
                            <Badge
                              key={index}
                              pill
                              bg="primary"
                              className="me-2"
                              style={{ cursor: "pointer" }}
                              onClick={() => removeTag(category, "category")}
                            >
                              {category?.label} <span>&times;</span>
                            </Badge>
                          ))}
                        {jobTypes &&
                          jobTypes.map((jobType: any, index: any) => (
                            <Badge
                              key={index}
                              pill
                              bg="success"
                              className="me-2"
                              style={{ cursor: "pointer" }}
                              onClick={() => removeTag(jobType, "jobType")}
                            >
                              {jobType?.label} <span>&times;</span>
                            </Badge>
                          ))}
                      </div>
                      {/* Tags Display ends */}
                    </div>
                  </div>

                  <JobsList
                    categories={categories}
                    jobTypes={jobTypes}
                    salaryMin={salaryMin}
                    salaryMax={salaryMax}
                    industry={formValues.industry}
                    location={formValues.location}
                    sortOrder={sortOrder} // Pass sortOrder
                    onSortChange={handleSortChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <AuthFooterScreen />

      <Offcanvas show={show} onHide={handleClose} placement={"end"}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Filters</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form>
            <h3>Category</h3>
            <div className="checkcategories comnbrdrGap mb-5">
              <div className="scrollHolder">
                {
                  /*["Development","Testing","Design"].map(*/
                  jobCategory &&
                    jobCategory.map((category: any, index: any) => (
                      <Form.Check
                        key={index}
                        type="checkbox"
                        label={`${category?.categoryName} (${category?.jobCount})`}
                        value={category?.id}
                        cat-name={category?.categoryName}
                        onChange={(e) => handleCheckboxChange(e, "category")}
                        //checked={categories.includes(category?.id)}
                        checked={categories.some(
                          (item: any) => item.value === category?.id
                        )}
                      />
                    ))
                }
                {/* <Form.Check type="checkbox" label="All (50)" />
							<Form.Check type="checkbox" label="Digital & Creative (5)" /> */}
              </div>
            </div>
            <h3>Job Type</h3>
            <div className="checkcategories comnbrdrGap mb-5">
              <div className="scrollHolder">
                {jobType &&
                  jobType.map((jobTypee: any, index: any) => (
                    <Form.Check
                      key={index}
                      type="checkbox"
                      label={`${jobTypee?.typeName} (${jobTypee?.jobCount})`}
                      value={jobTypee?.id}
                      cat-name={jobTypee?.typeName}
                      onChange={(e) => handleCheckboxChange(e, "jobType")}
                      checked={jobTypes.some(
                        (item: any) => item.value === jobTypee?.id
                      )}
                    />
                  ))}
                {/* <Form.Check type="checkbox" label="All (50)" />
							<Form.Check type="checkbox" label="Temporary (2)" /> */}
              </div>
            </div>
            <h3>Salary</h3>
            <div className="checkcategories comnbrdrGap mb-5">
              <div className="App">
                <div className="multi-range-slider-container">
                  <h6>Range</h6>
                  <MultiRangeSlider
                    min={salaryRange.minSalary || 1}
                    max={salaryRange.maxSalary || 100000}
                    step={Math.ceil((salaryRange.maxSalary - salaryRange.minSalary) / 100)}
                    minValue={(salaryMin ?? salaryRange.minSalary) || 1}
                    maxValue={(salaryMax ?? salaryRange.maxSalary) || 100000}
                    onInput={(e) =>
                      handleCheckboxChange(
                        { minValue: e.minValue, maxValue: e.maxValue },
                        "salary"
                      )
                    }
                  ></MultiRangeSlider>
                  <div className="slidervaluesHolder">
                    <div style={{ margin: "1px" }}>{salaryMin ?? salaryRange.minSalary}</div>
                    <div style={{ margin: "1px" }}>{salaryMax ?? salaryRange.maxSalary}</div>
                  </div>
                </div>
              </div>
            </div>
            {/* <button
              className="btn w-100"
              type="button"
              onClick={handleApplyFilter}
            >
              Apply Filter
            </button> */}
          </Form>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};
export default JobsListingScreen;
